
// TOOLTIPS
(function ($) {
    $('[data-toggle="tooltip"]').tooltip();
})(jQuery);
